var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getByIdAPI, setState } from "../../../../redux/crudSlice";
import { store } from "../../../../store/store";
import { getAFRDashboard, getIRDashboard, IRPagingURL, PSGKeys, updateaAFRDashboardCount, updateIRDashboardCount } from "./entity1";
var dispatch = store.dispatch;
export var DashboardCount = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, responseAFR, responseIR;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Promise.all([dispatch(getByIdAPI({
                        key: PSGKeys.getDashboardAFR,
                        request: params === null || params === void 0 ? void 0 : params.request,
                        url: getAFRDashboard
                    })), dispatch(getByIdAPI({
                        key: PSGKeys.getDashboardIR,
                        request: params === null || params === void 0 ? void 0 : params.request,
                        url: getIRDashboard
                    }))])];
            case 1:
                _a = _b.sent(), responseAFR = _a[0], responseIR = _a[1];
                return [2 /*return*/, {}];
        }
    });
}); };
export var UpdateDashboardCounts = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, _d, responseAFR, responseIR;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PSGKeys.updateAFRDashboard : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? updateaAFRDashboardCount : _c;
                return [4 /*yield*/, Promise.all([dispatch(getByIdAPI({
                            key: key,
                            request: request,
                            url: url
                        })), dispatch(getByIdAPI({
                            key: PSGKeys.updateIRDashboard,
                            request: request,
                            url: updateIRDashboardCount
                        }))])];
            case 1:
                _d = _e.sent(), responseAFR = _d[0], responseIR = _d[1];
                return [2 /*return*/, {
                        dashboardCountAFR: responseAFR,
                        dashboardCountIR: responseIR
                    }];
        }
    });
}); };
export var IRPagingAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PSGKeys : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? IRPagingURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 ? void 0 : _res$payload.value];
        }
    });
}); };
export var IRReportsCountAPI = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _open$payload$value$c, _open$payload, _submitted$payload$va, _submitted$payload, _reverted$payload$val, _reverted$payload, _closed$payload$value, _closed$payload, _Lapsed$payload$value, _Lapsed$payload, _a, open, submitted, reverted, closed, Lapsed, result;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Promise.all([dispatch(getByIdAPI({
                        key: PSGKeys.count,
                        url: IRPagingURL,
                        request: {
                            status: "Open"
                        }
                    })), dispatch(getByIdAPI({
                        key: PSGKeys.count,
                        url: IRPagingURL,
                        request: {
                            status: "Submitted"
                        }
                    })), dispatch(getByIdAPI({
                        key: PSGKeys.count,
                        url: IRPagingURL,
                        request: {
                            status: "Reverted"
                        }
                    })), dispatch(getByIdAPI({
                        key: PSGKeys.count,
                        url: IRPagingURL,
                        request: {
                            status: "Closed"
                        }
                    })), dispatch(getByIdAPI({
                        key: PSGKeys.count,
                        url: IRPagingURL,
                        request: {
                            status: "Lapsed"
                        }
                    }))])];
            case 1:
                _a = _b.sent(), open = _a[0], submitted = _a[1], reverted = _a[2], closed = _a[3], Lapsed = _a[4];
                result = dispatch(setState({
                    key: PSGKeys.count,
                    value: {
                        open: (_open$payload$value$c = open === null || open === void 0 || (_open$payload = open.payload) === null || _open$payload === void 0 || (_open$payload = _open$payload.value) === null || _open$payload === void 0 ? void 0 : _open$payload.count) !== null && _open$payload$value$c !== void 0 ? _open$payload$value$c : 0,
                        submitted: (_submitted$payload$va = submitted === null || submitted === void 0 || (_submitted$payload = submitted.payload) === null || _submitted$payload === void 0 || (_submitted$payload = _submitted$payload.value) === null || _submitted$payload === void 0 ? void 0 : _submitted$payload.count) !== null && _submitted$payload$va !== void 0 ? _submitted$payload$va : 0,
                        reverted: (_reverted$payload$val = reverted === null || reverted === void 0 || (_reverted$payload = reverted.payload) === null || _reverted$payload === void 0 || (_reverted$payload = _reverted$payload.value) === null || _reverted$payload === void 0 ? void 0 : _reverted$payload.count) !== null && _reverted$payload$val !== void 0 ? _reverted$payload$val : 0,
                        closed: (_closed$payload$value = closed === null || closed === void 0 || (_closed$payload = closed.payload) === null || _closed$payload === void 0 || (_closed$payload = _closed$payload.value) === null || _closed$payload === void 0 ? void 0 : _closed$payload.count) !== null && _closed$payload$value !== void 0 ? _closed$payload$value : 0,
                        Lapsed: (_Lapsed$payload$value = Lapsed === null || Lapsed === void 0 || (_Lapsed$payload = Lapsed.payload) === null || _Lapsed$payload === void 0 || (_Lapsed$payload = _Lapsed$payload.value) === null || _Lapsed$payload === void 0 ? void 0 : _Lapsed$payload.count) !== null && _Lapsed$payload$value !== void 0 ? _Lapsed$payload$value : 0
                    }
                }));
                return [2 /*return*/, result.payload.value];
        }
    });
}); };
